import { Component, ChangeDetectionStrategy } from '@angular/core';
import { DiallerService } from '@app/dialler/services';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { WorkService } from '../services';

@Component({
  selector: 'app-nailup-dropped-modal',
  templateUrl: './nailup-dropped-modal.component.html',
  styles: [],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NailupDroppedModalComponent {
  constructor(
    public activeModal: NgbActiveModal,
    private workSvc: WorkService,
    private diallerSvc: DiallerService
  ) {}

  break() {
    this.workSvc.showStateModal();
    this.activeModal.close();
  }

  nailup() {
    this.diallerSvc.nailInAgain();

    this.activeModal.close();
  }
}
